import React from 'react';
import { Button, ButtonGroup } from 'react-bootstrap-buttons';
import { useSelector, useDispatch } from 'react-redux';
import { changeTypeRequest } from '../../state/actions/createData';
import Key from './key';

export default function Header() {
  const mapType = useSelector((state) => state.data.mapType);
  const dispatch = useDispatch();

  function buttonClick(num) {
    dispatch(changeTypeRequest(num));
  }

  function buttonRender() {
    const style = {
      margin: '25px 0',
    };

    if (mapType === 1) {
      return (
        <ButtonGroup style={style}>
          <Button active>One vaccination</Button>
          <Button
            onClick={() => {
              buttonClick(2);
            }}
          >
            Two vaccinations
          </Button>
          <Button
            onClick={() => {
              buttonClick(3);
            }}
          >
            Boosters
          </Button>
        </ButtonGroup>
      );
    }
    if (mapType === 2) {
      return (
        <ButtonGroup style={style}>
          <Button
            onClick={() => {
              buttonClick(1);
            }}
          >
            One vaccination
          </Button>
          <Button active>Two vaccinations</Button>
          <Button
            onClick={() => {
              buttonClick(3);
            }}
          >
            Boosters
          </Button>
        </ButtonGroup>
      );
    }
    // default is 3
    return (
      <ButtonGroup style={style}>
        <Button
          onClick={() => {
            buttonClick(1);
          }}
        >
          One vaccination
        </Button>
        <Button
          onClick={() => {
            buttonClick(2);
          }}
        >
          Two vaccinations
        </Button>
        <Button active>Boosters</Button>
      </ButtonGroup>
    );
  }

  return (
    <header>
      <h1>World vaccination map</h1>
      <p>
        This map shows how each country is doing with its COVID-19 vaccine
        rollout and is updated automatically. Toggle between one, two and three
        (booster) doses and click on the country for more information.
      </p>

      {buttonRender()}

      <Key />
    </header>
  );
}
